import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzsyxqr3tp: FaireProductEntity = {
  token: "p_rzsyxqr3tp",
  type: "product",
  name: 'White Plum Berry Norfolk Cypress Real Touch Wreath - 14"',
  brandToken: "b_9i65h1cb",
  brandName: "Luxe B Co",
  imageUrl:
    "https://cdn.faire.com/fastly/7fd1340c64161216508c6f0fe6121a18a1ec1f8e856deb41ccea2c08ee2321d5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36facc87538f481b7559a5b806a34477d38d52de0d7349e792d7523f6a2679a5.png",
    "https://cdn.faire.com/fastly/c360be2bff294f4b937700307f8ae580896f94e5b791417b835d64b5cf603737.png",
    "https://cdn.faire.com/fastly/7334265b31511a94850aac7862a653b2ee43d9e082988dda9ed6a9c965fca6af.png",
    "https://cdn.faire.com/fastly/07d22b4351f0e6c1700bdb90bf8b00a56c9291ed666df121c7ce5b9c86f3d357.png",
    "https://cdn.faire.com/fastly/807dad82b9ed8f058e3838e04b3393e28862ed23a4f96caa656417dbd9efe9bf.png",
  ],
  priceDollars: 14.95,
  description:
    '𝐃𝐢𝐦𝐞𝐧𝐬𝐢𝐨𝐧𝐬:\n14" Diameter\n\nWhite Plum Berry Norfolk Cypress Real Touch Wreath by Luxe B Co. is our high-quality, realistic "Real Touch" holiday decoration and the most popular item of the 2025 Christmas Decor.\n\nNatural Touch technology makes the Wreath look realistic by giving it a lifelike appearance and feel. Luxe B Co. offers a variety of holiday decoration products, including Norfolk Pine Wreaths, Norfolk Pine Stem Picks, Vintage Bells, and Velvet Ribbons. These items can further complement your holiday decor.\n\nWhite Plum Berry Norfolk Cypress Real Touch Wreath branches can be easily maneuvered for styling.\n\n\nOur faux garlands, wreaths, and stems look beautifully lifelike and are designed for indoor display. They are not suitable for outdoor use.',
  tags: [],
  msrpDollars: 29.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:15.207Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
